// const objectToQueryString = parms => {
// 	const queryString = Object.entries(parms)
// 		.map(e => e.join('='))
// 		.join('&');

// 	return `?${queryString}`;
// };

const objectToQuerystring = obj => {
	var returnStr = Object.keys(obj).reduce(function (str, key, i) {
		var delimiter, val;
		delimiter = str == '' ? '?' : '&';
		if (obj[key] != null && obj[key] != 'ALL') {
			key = encodeURIComponent(key);
			val = encodeURIComponent(obj[key]);
			return [str, delimiter, key, '=', val].join('');
		} else {
			return str;
		}
	}, '');

	returnStr += returnStr == '' ? '?' : '&';
	if (returnStr.indexOf('currentPage') < 0 || returnStr.indexOf('pageUnit') < 0) {
		returnStr += 'currentPage=0&pageUnit=0';
	}

	return returnStr;
};

// export default objectToQueryString;
export default objectToQuerystring;
